<template>
    <div class="growth-period-container">
        <div class="page-content">
            <div class="operation-bar">
                <el-button type="primary" size="mini" @click="handleCreate">+新增</el-button>
                <el-button type="danger" size="mini" @click="handleBatchDelete"
                    :disabled="!selectedRows.length">删除</el-button>
                <div class="search-box">
                    <span style="margin-right: 10px; color: #fff;">草莓品种</span>
                    <el-select v-model="varietyId" placeholder="请选择" style="width: 200px;" size="mini" clearable>
                        <el-option v-for="item in varietyOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin: 0 10px; color: #fff;">状态</span>
                    <el-select v-model="searchStatus" placeholder="请选择" style="width: 200px;" size="mini" clearable>
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                    <el-button icon="el-icon-search" style="margin-left: 10px;" size="mini" type="primary"
                        @click="handleSearch">查询</el-button>
                </div>
            </div>
            <el-table :data="tableData" border style="width: 100%" height="60vh"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index" width="80" align="center">
                </el-table-column>
                <el-table-column prop="varietyName" label="草莓品种"></el-table-column>
                <el-table-column prop="totalDays" label="生长时期总天数"></el-table-column>
                <el-table-column label="各时期天数">
                    <template slot-scope="scope">
                        <div v-for="detail in scope.row.configDetails || scope.row.details" :key="detail.id"
                            style="margin-bottom: 5px;">
                            {{ detail.basicStageName }}: {{ detail.days }}天
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column prop="enabled" label="启用" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enabled === 1 ? 'success' : 'info'">{{ scope.row.enabled === 1 ? '启用' :
                            '禁用' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="color: #2680DD;" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" style="color: #04FF9F;" @click="handleView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </div>

        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="850px" @close="handleDialogClose">
            <el-form :model="formData" :rules="rules" ref="formRef" label-position="top" label-width="120px">
                <el-form-item label="草莓品种:" prop="varietyId">
                    <el-select v-model="formData.varietyId" placeholder="请选择" style="width: 100%;"
                        @change="handleVarietyChange">
                        <el-option v-for="item in varietyOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生长时期天数配置:" prop="details">
                    <div class="config-table">
                        <el-table :data="formData.details" border style="width: 100%">
                            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
                            <el-table-column label="*生长时期名称" width="200">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.basicStageId" placeholder="请选择" style="width: 100%;"
                                        @change="handleStageChange(scope.$index)">
                                        <el-option v-for="stage in stageOptions" :key="stage.id" :label="stage.name"
                                            :value="stage.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="判定标准">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.judgmentCriteria || '' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="注意事项">
                                <template slot-scope="scope">
                                    <span >{{ scope.row.precautions || '' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="标准时长区间">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.stdDurationMin }}-{{ scope.row.stdDurationMax }}天</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="*该时期天数(天)">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.days" :min="1" :precision="0" size="mini"
                                        style="width: 100%;" placeholder="请输入"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini"
                                        @click="removeDetail(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="add-button-container">
                            <el-button type="primary" icon="el-icon-plus" plain style="margin: 10px 0; width: 100%;"
                                size="mini" @click="addDetail">添加</el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="状态:" prop="enabled">
                    <el-switch v-model="formData.enabled" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 查看详情弹窗 -->
        <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="500px">
            <div>
                <p><strong>草莓品种：</strong>{{ viewRow.varietyName }}</p>
                <p><strong>生长时期总天数：</strong>{{ viewRow.totalDays }}天</p>
                <p><strong>各时期天数：</strong></p>
                <div style="margin-left: 20px;">
                    <div v-for="detail in viewRow.configDetails || viewRow.details" :key="detail.id"
                        style="margin-bottom: 5px;">
                        {{ detail.basicStageName }}：{{ detail.days }}天
                    </div>
                </div>
                <p><strong>状态：</strong>{{ viewRow.enabled === 1 ? '启用' : '禁用' }}</p>
                <p><strong>创建时间：</strong>{{ formatTime(viewRow.createTime) }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from '@/axios'
import { baseUrl } from '@/axios/baseUrl'

export default {
    name: 'GrowthPeriodManagement',
    data() {
        return {
            tableData: [],
            selectedRows: [],
            varietyId: '',
            searchStatus: '',
            page: 1,
            pageSize: 10,
            totalCount: 0,
            dialogVisible: false,
            dialogTitle: '新增生长时期配置',
            formData: {
                id: '',
                varietyId: '',
                varietyName: '',
                details: [],
                enabled: 1
            },
            isEdit: false,
            rules: {
                details: [
                    { required: true, message: '请配置生长时期', trigger: 'change' }
                ]
            },
            viewDialogVisible: false,
            viewRow: {},
            varietyOptions: [],
            stageOptions: [],
        }
    },
    created() {
        this.fetchData()
        this.fetchVarietyOptions()
        this.fetchStageOptions()
    },
    methods: {
        async fetchData() {
            try {
                const params = {
                    page: this.page,
                    pageSize: this.pageSize,
                    varietyId: this.varietyId,
                    enabled: this.searchStatus,
                }
                const res = await axios.post(baseUrl + '/api/farming/growth-stage-config/list-page', params)
                if (res.code === 200) {
                    this.tableData = res.data.list || []
                    this.totalCount = parseInt(res.data.totalCount) || 0
                }
            } catch (error) {
            }
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection
        },
        handleSearch() {
            this.page = 1
            this.fetchData()
        },
        handleCreate() {
            this.isEdit = false
            this.dialogTitle = '新增生长时期配置'
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.resetFields()
                this.formData = {
                    id: '',
                    varietyId: '',
                    varietyName: '',
                    details: [],
                    enabled: 1
                }
                // 添加一个默认行
                this.addDetail()
            })
        },
        handleEdit(row) {
            this.isEdit = true
            this.dialogTitle = '编辑生长时期配置'
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.resetFields()
                this.formData = {
                    ...row,
                    details: row.configDetails || []
                }
            })
        },
        handleView(row) {
            this.viewRow = { ...row }
            this.viewDialogVisible = true
        },
        handleDialogClose() {
            this.$refs.formRef && this.$refs.formRef.resetFields()
            this.isEdit = false
            this.formData = {
                id: null,
                varietyId: '',
                varietyName: '',
                details: [],
                enabled: 1
            }
        },
        async handleSubmit() {
            if (this.isEdit) {
                // 编辑模式：使用表单验证
                this.$refs.formRef.validate(async (valid) => {
                    if (valid) {
                        try {
                            // 计算总天数
                            const submitData = {
                                ...this.formData,
                                varietyName: this.varietyOptions.find(item => item.value === this.formData.varietyId).label
                            }
                            const url = '/api/farming/growth-stage-config/edit'
                            const res = await axios.post(baseUrl + url, submitData)
                            if (res.code === 200) {
                                this.$message.success('更新成功')
                                this.dialogVisible = false
                                this.fetchData()
                            }
                        } catch (error) {
                        }
                    }
                })
            } else {
                // 新增模式：自定义验证
                if (!this.formData.varietyId) {
                    this.$message.error('请选择草莓品种')
                    return
                }

                if (!this.formData.details || this.formData.details.length === 0) {
                    this.$message.error('请至少添加一条生长时期配置')
                    return
                }

                // 验证每个详情项
                for (let i = 0; i < this.formData.details.length; i++) {
                    const detail = this.formData.details[i]
                    if (!detail.basicStageId) {

                        this.$message.error(`第${i + 1}行：请选择生长时期名称`)
                        return
                    }
                    if (!detail.days || detail.days < 1) {
                        this.$message.error(`第${i + 1}行：请输入该时期天数`)
                        return
                    }
                }

                try {
                    // 计算总天数
                    const submitData = {
                        ...this.formData,
                        id: null
                    }
                    const url = '/api/farming/growth-stage-config/add'
                    const res = await axios.post(baseUrl + url, submitData)
                    if (res.code === 200) {
                        this.$message.success('新增成功')
                        this.dialogVisible = false
                        this.fetchData()
                    }
                } catch (error) {
                }
            }
        },
        async handleBatchDelete() {
            if (!this.selectedRows.length) return
            try {
                await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个配置吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                const ids = this.selectedRows.map(row => row.id)
                const res = await axios.post(baseUrl + '/api/farming/growth-stage-config/delete-batch', ids)
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.fetchData()
                }
            } catch (error) {
                if (error !== 'cancel') {
                }
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.page = val
            this.fetchData()
        },
        formatTime(time) {
            if (!time) return ''
            const date = new Date(time)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).replace(/\//g, '/')
        },
        // 获取草莓品种选项
        async fetchVarietyOptions() {
            try {
                const res = await axios.post(baseUrl + '/api/basic/strawberry-variety/selection')
                if (res.code === 200) {
                    this.varietyOptions = res.data.map(item => ({
                        label: item.varietyName,
                        value: item.id
                    }))
                }
            } catch (error) {
            }
        },
        // 获取生长时期选项
        async fetchStageOptions() {
            try {
                const res = await axios.post(baseUrl + '/api/basic/growth-stage/selection')
                if (res.code === 200) {
                    this.stageOptions = res.data.map(item => ({
                        id: item.id,
                        name: item.stageName,
                        judgmentCriteria: item.judgmentCriteria,
                        stdDurationMin: item.stdDurationMin,
                        stdDurationMax: item.stdDurationMax,
                        precautions: item.precautions
                    }))
                }
            } catch (error) {
            }
        },
        // 草莓品种变化处理
        handleVarietyChange(value) {
            const selectedVariety = this.varietyOptions.find(item => item.value === value)
            if (selectedVariety) {
                this.formData.varietyName = selectedVariety.label
            }
        },
        // 生长时期变化处理
        handleStageChange(index) {
            const detail = this.formData.details[index]
            const selectedStage = this.stageOptions.find(item => item.id === detail.basicStageId)
            console.log('selectedStage', selectedStage)
            
            if (selectedStage) {
                detail.basicStageName = selectedStage.name
                detail.judgmentCriteria = selectedStage.judgmentCriteria
                detail.precautions = selectedStage.precautions
                detail.stdDurationMin = selectedStage.stdDurationMin
                detail.stdDurationMax = selectedStage.stdDurationMax
            }
        },
        // 添加详情行
        addDetail() {
            this.formData.details.push({
                id: undefined,
                basicStageId: '',
                basicStageName: '',
                judgmentCriteria: '',
                precautions: '',
                stdDurationMin: 0,
                stdDurationMax: 0,
                days: 1
            })
        },
        // 删除详情行
        removeDetail(index) {
            this.formData.details.splice(index, 1)
        },

    }
}
</script>

<style scoped lang="less">
.growth-period-container {
    .page-title {
        font-size: 20px;
        color: #fff;
        margin-bottom: 20px;
    }

    .page-content {
        background: rgba(0, 11, 47, 0.3);
        padding: 20px;
        border-radius: 4px;

        .operation-bar {
            margin-bottom: 20px;
            display: flex;
            align-items: center;

            .search-box {
                margin-left: auto;
                display: flex;
                align-items: center;
            }
        }

        .pagination-container {
            margin-top: 20px;
            text-align: right;
        }

        .config-table {
            .add-button-container {
                margin-top: 15px;
                text-align: center;
                padding: 15px;
                border: 2px dashed #dcdfe6;
                border-radius: 4px;
                background-color: #fafafa;
            }
        }
    }
}
</style>